import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
export function toArray(candidate) {
  if (candidate === undefined || candidate === false) return [];
  return Array.isArray(candidate) ? candidate : [candidate];
}
export function getFieldId(namePath, formName) {
  if (!namePath.length) return undefined;
  var mergedId = namePath.join('_');
  return formName ? "".concat(formName, "_").concat(mergedId) : mergedId;
}
var isValidElement = React.isValidElement; // type AnyObject = Record<any, any>;
// type RenderProps = undefined | AnyObject | ((originProps: AnyObject) => AnyObject | undefined);

export { isValidElement };
export function replaceElement(element, replacement, props) {
  if (!isValidElement(element)) return replacement;
  return /*#__PURE__*/React.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
}
export function cloneElement(element, props) {
  return replaceElement(element, element, props);
}
export function useForceUpdate() {
  var _React$useReducer = React.useReducer(function (x) {
    return x + 1;
  }, 0),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      forceUpdate = _React$useReducer2[1];

  return forceUpdate;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-form/src/util.js